import React from "react";
import {
  modalStyle,
  overlayStyle,
  primaryBtnStyle,
} from "../../styles/commonStyles";
import COLORS from "../../constants/colors";

export default function LandmarkUnlockModal({ landmark, onClose }) {
  if (!landmark) return null;

  return (
    <div style={overlayStyle()}>
      <div style={modalStyle()}>
        <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>✨</div>

        <div
          style={{
            fontSize: "1.4rem",
            fontWeight: 800,
            color: COLORS.text,
          }}
        >
          解锁新地标：{landmark.name}
        </div>

        <div
          style={{
            color: COLORS.subtext,
            marginTop: "0.7rem",
            lineHeight: 1.7,
          }}
        >
          {landmark.desc}
          <br />
          （这里已预留“30秒法语文化短片”位置，可后续接入视频资源）
        </div>

        <button
          onClick={onClose}
          style={{
            ...primaryBtnStyle(),
            marginTop: "1.2rem",
            width: "100%",
          }}
        >
          太好了
        </button>
      </div>
    </div>
  );
}